import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from "./8.png";

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = selectLang => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = type => {
    return selectedType === type || selectedType === "all"
      ? "display"
      : "display-none";
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 270.4 363.4"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g  id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text
            transform="translate(125 155)"
            font-size="10"
            fill="#58595b"
            font-family="STHeitiTC-Medium, Heiti TC"
            font-weight="500"
          >
            天台
          </text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text
            transform="translate(125 155)"
            font-size="11"
            fill="#58595b"
            font-family="Helvetica-Bold, Helvetica"
            font-weight="700"
          >
            КРЫША
          </text>
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <text
            transform="translate(125 155)"
            font-size="9.6"
            fill="#58595b"
            font-family="Termina-Bold, Termina"
            font-weight="700"
          >
            Roof top Floor
          </text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/b/8.js